import format from "date-fns/format";
import isToday from "date-fns/isToday";
import React from "react";

export default function Head(props) {
    const dataFrom = props.dataLoadedAt ? new Date(props.dataLoadedAt) : null;
    return (
        <div className="book-show__head pl-0">
            <div className="book-show__title book-show__title--fixed-height w-100">
                <div className="d-flex align-items-center h-100 justify-content-between">
                    <div>
                        АРМ логиста
                        {props.dataLoadedAt && (
                            <span className="text-muted text-nowrap font-size-12 pl-2">
                                Данные обновлены в {format(dataFrom, isToday(dataFrom) ? "HH:mm" : "dd.MM.yyyy HH:mm")}
                            </span>
                        )}
                    </div>
                    {props.children}
                </div>
            </div>
        </div>
    );
}
